import { types, } from 'mobx-state-tree';
const ErrorDialogModel = types.model({
    open: types.boolean,
    title: types.string,
    message: types.string,
})
    .actions((self) => ({
    showError(title, message) {
        self.title = title;
        self.message = message;
        self.open = true;
    },
    closeError() {
        self.open = false;
    },
}));
export default ErrorDialogModel;
//# sourceMappingURL=ErrorDialogModel.js.map